export default __webpack_public_path__ + "static/media/step_3.092d8763.jpeg";